<template>
  <a-layout class="pledge">
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content>
      <div class="pledge-body">
        <div class="banner">
          <div class="banner-content">
            <div class="_left">
              <h1>{{ $t('investment.pledge_earn') }}</h1>
              <p>{{ $t('investment.principal_safe_mining') }}</p>
            </div>
            <div class="_right">
              <div v-if="isLogin" class="account">
                <div class="head">
                  <div class="row">
                    <span class="color-gray font-12 cursor">{{ $t('investment.term_position_valuation') }} <icon-caret-down class="cursor"/></span>
                    <icon-eye class="cursor color-gray"/>
                  </div>
                  <div class="row">
                    <span class="font-18 color-black font-bold">-- USDT</span>
                  </div>
                  <div class="row">
                    <span class="font-12 color-gray">{{ $t('investment.cumulative_earnings') }}</span>
                  </div>
                  <div class="row">
                    <span class="font-14 color-black">0.00000000</span>
                  </div>
                </div>
                <div class="bottom">
                  <a-button class="button">{{ $t('investment.go_to_account') }}</a-button>
                  <a-button class="button">{{ $t('investment.go_to_history') }}</a-button>
                </div>
              </div>
              <div v-else class="not-log">
                <svg width="50" height="50" viewBox="0 0 66 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M52.962 3.83c3.23 4.245 2.435 10.285-1.776 13.49-4.212 3.204-10.245 2.36-13.475-1.886-3.23-4.245-2.435-10.285 1.776-13.49C43.7-1.26 49.732-.415 52.962 3.83Z"
                      fill="#9C69FF"></path>
                  <path
                      d="M23.228 29.47c-4.163-5.471-3.138-13.254 2.29-17.383 5.426-4.13 13.2-3.042 17.363 2.429 4.163 5.47 3.138 13.253-2.29 17.382-5.426 4.13-13.2 3.042-17.363-2.428Z"
                      fill="#05C3DD"></path>
                  <g filter="url(#assetLogin_svg__a)">
                    <rect x="9" y="22" width="47" height="33" rx="1.82" fill="url(#assetLogin_svg__b)"
                          fill-opacity="0.5"></rect>
                    <rect x="8.75" y="21.75" width="47.5" height="33.5" rx="2.07" stroke="#393939"
                          stroke-width="0.5"></rect>
                  </g>
                  <path fill="#05C3DD" d="M47.233 35.597H58v6.63H47.233z"></path>
                  <defs>
                    <linearGradient id="assetLogin_svg__b" x1="10.152" y1="32.033" x2="15.541" y2="7.514"
                                    gradientUnits="userSpaceOnUse">
                      <stop stop-color="#B8B8B8"></stop>
                      <stop offset="1" stop-color="#393939" stop-opacity="0"></stop>
                    </linearGradient>
                    <filter id="assetLogin_svg__a" x="0.191" y="13.191" width="64.618" height="50.618"
                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                      <feGaussianBlur in="BackgroundImageFix" stdDeviation="4.154"></feGaussianBlur>
                      <feComposite in2="SourceAlpha" operator="in"
                                   result="effect1_backgroundBlur_2497_16220"></feComposite>
                      <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_2497_16220" result="shape"></feBlend>
                    </filter>
                  </defs>
                </svg>
                <p>{{ $t('investment.login_to_view_earnings') }}</p>
                <a-button class="button">{{ $t('common.login') }}</a-button>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="label">
            <p class="title">{{ $t('investment.all_products') }}</p>
            <div class="coinList" :class="{'openAll': openAll}">
              <div class="item" v-for="i in 20" :key="index">
                <div class="item-con">
                  <p class="font-20 color-gray font-bold">ETH 2.0</p>
                  <div class="coinImage">
                    <img src="@/assets/images/coin/eth.png" alt="">
                  </div>
                  <p class="font-14 color-gray">APR</p>
                  <p class="font-24 color-black font-bold">4.00%</p>
                  <a-button class="button" @click="visible = true">{{ $t('investment.staking') }}</a-button>
                </div>
              </div>
            </div>
            <a-button class="seeAll" :class="{'hideBtn': openAll == false}" @click="openAll = !openAll">
              {{ openAll ? $t('common.collapse') : $t('common.expand_all') }}
              <icon-down/>
            </a-button>
          </div>

          <!--          质押赚币常见问题-->
          <div class="label">
                            <p class="title">{{ $t('investment.pledge_earn_faq') }}</p>
            <div class="collapse">
              <a-collapse expand-icon-position="right" :default-active-key="['1']">
                <a-collapse-item :header="$t('investment.proof_of_stake_faq_question')" key="1">
                  <p>{{ $t('investment.proof_of_stake_description') }}</p>
                </a-collapse-item>
                <a-collapse-item :header="$t('investment.staking_benefit_faq_question')" key="2">
                  <p>{{ $t('investment.staking_benefit_one_description') }}<br/>{{ $t('investment.staking_benefit_two_description') }}<br/>{{ $t('investment.staking_benefit_three_description') }}<br/>{{ $t('investment.staking_benefit_four_description') }}</p>
                </a-collapse-item>
                <a-collapse-item :header="$t('investment.annual_return_faq_question')" key="3">
                  <p>{{ $t('investment.staking_return_unchanged') }}</p>
                </a-collapse-item>
                <a-collapse-item :header="$t('investment.total_return_faq_question')" key="4">
                  <p>{{ $t('investment.total_return_description') }}</p>
                </a-collapse-item>
                <a-collapse-item :header="$t('investment.reward_time_faq_question')" key="5">
                  <p>{{ $t('investment.staking_interest_schedule') }}</p>
                </a-collapse-item>
                <a-collapse-item
                    :header="$t('investment.redemption_type_faq_question')" key="6">
                  <p>{{ $t('investment.standard_redemption_description') }}<br>{{ $t('investment.fast_redemption_description') }}</p>
                </a-collapse-item>
              </a-collapse>
            </div>
          </div>
        </div>
      </div>

      <!--      立即申购弹窗-->
      <a-modal :visible="visible"
               align-center
               :render-to-body="false"
               :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
               modal-class="mode-box"
               :hide-title="true"
               :footer="false">
        <div class="modal-con">
          <div class="title-box flex align-center jus-bet">
            <div class="flex align-center">
              <span class="font-20 color-black font-bold">{{ $t('investment.staking') }}</span>
              <img src="@/assets/images/coin/eth.png" alt="">
              <span class="font-20 color-black font-bold">ETH2.0</span>
            </div>
            <icon-close @click="visible = false" class="color-black font-bold pointer" size="24"/>
          </div>
          <div class="modal-container">
            <div class="left">
              <div class="label">
                <div class="_hd">
                  <span class="font-14 color-black font-bold">{{ $t('investment.staking_amount') }}</span>
                </div>
                <a-input class="inputBox" :placeholder="$t('investment.minimum_eth_staking_amount')">
                  <template #suffix>
                    <span class="color-primary cursor">{{ $t('investment.max') }}</span>
                  </template>
                </a-input>
              </div>
              <div class="label">
                <div class="row">
                  <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                    <span class="font-12 color-gray dotted cursor">{{ $t('investment.available_balance') }}</span>
                    <template #content>
                      <span class="color-always-white font-12">{{ $t('investment.excludes_spot_copy_trading') }}</span>
                    </template>
                  </a-tooltip>
                  <span class="ml-5 color-gray font-12">0.00000000 ETH</span>
                </div>
              </div>
              <div class="label">
                <div class="_hd">
                  <span class="font-14 color-black font-bold">{{ $t('investment.quantity_limit') }}</span>
                </div>
                <div class="row">
                  <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                    <span class="font-12 color-gray dotted cursor">{{ $t('investment.staking_amount_limit') }} </span>
                    <template #content>
                      <p class="font-14 font-bold color-always-white">{{ $t('investment.staking_limit_summary') }}</p>
                      <p>{{ $t('investment.maximum_stake_unlimited') }}</p>
                      <p>{{ $t('investment.daily_staking_remaining_unlimited') }}</p>
                      <p>{{ $t('investment.eth_staking_remaining_unlimited') }}</p>
                    </template>
                  </a-tooltip>
                  <span class="ml-5 color-black font-bold font-14">{{ $t('investment.unlimited') }}</span>
                </div>
              </div>
              <div class="label">
                <div class="tips">
                  <p class="font-12 font-bold color-black">{{ $t('investment.pre_staking_notice') }}</p>
                  <a-checkbox-group class="checkboxGroup">
                    <a-checkbox value="1">
                      <span class="font-12 color-gray">{{ $t('investment.staking_risk_notice') }} <strong class="font-bold color-black dotted">{{ $t('assets.finance_account') }}</strong> {{ $t('investment.redeem_your_assets') }}</span>
                    </a-checkbox>
                    <a-checkbox value="2">
                      <span class="font-12 color-gray">{{ $t('investment.agreement_read_notice') }} <strong class="font-bold color-black dotted">{{ $t('investment.pledge_agreement') }}</strong>{{ $t('investment.agreement_acceptance_notice') }}</span>
                    </a-checkbox>
                  </a-checkbox-group>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="_top">
                <div class="row">
                  <span class="font-14 color-black font-bold">{{ $t('investment.return_mode') }}</span>
                  <span class="font-14 color-black font-bold">{{ $t('investment.daily_interest_settlement') }}</span>
                </div>
                <div class="row">
                  <span class="font-14 color-black font-bold">APR</span>
                  <span class="font-14 color-black font-bold">4.00%</span>
                </div>
                <div class="row">
                  <span class="font-14 color-black font-bold">{{ $t('investment.estimated_daily_return') }}</span>
                  <span class="font-14 color-primary font-bold">0.00000000 ETH</span>
                </div>
              </div>
              <div class="_btm">
                <div class="row">
                  <span class="font-14 color-black font-bold">{{ $t('investment.order_period') }}</span>
                  <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                    <span class="font-14 color-black font-bold dotted cursor" @click="rdpType = !rdpType"><icon-swap /> {{ rdpType ? $t('investment.fast_redemption') : $t('investment.standard_redemption') }}</span>
                    <template #content>
                      <span>{{ $t('investment.redemption_type_switch_description') }}</span>
                    </template>
                  </a-tooltip>
                </div>
                <a-timeline :reverse="isReverse">
                  <a-timeline-item label="2023-12-01 17:07:11">{{ $t('investment.staking_time') }}</a-timeline-item>
                  <a-timeline-item label="2023-12-01 08:00:00">{{ $t('investment.interest_start_time') }}</a-timeline-item>
                  <a-timeline-item label="2023-12-01 08:00:00">{{ $t('investment.interest_payment_time') }}</a-timeline-item>
                  <a-timeline-item :label="$t('investment.staking_day')">{{ $t('investment.redemption_request_time') }}</a-timeline-item>
                  <a-timeline-item :label="rdpType ? 'D+10分钟' : 'D+5日'">{{ $t('investment.redemption_arrival_time') }}</a-timeline-item>
                </a-timeline>
              </div>
              <a-button class="confirmBtn">{{ $t('investment.confirm') }}</a-button>
            </div>
          </div>
          <div class="flex align-start jus-bet con-box" v-if="false">
            <div class="flex flex-column align-start con-right">
              <p class="font-16 color-black">{{ $t('investment.overview') }}</p>
              <div class="timeline">
                <a-timeline>
                  <a-timeline-item label="2017-03-10">{{ $t('investment.subscription_date') }}</a-timeline-item>
                  <a-timeline-item label="2018-05-12">{{ $t('easy_earn.interest_start_date') }}</a-timeline-item>
                  <a-timeline-item label="2020-09-30">{{ $t('investment.redemption_date') }}</a-timeline-item>
                </a-timeline>
              </div>
              <div class="cell flex align-center jus-bet">
                <span class="font-14 color-gray">{{ $t('investment.expected_annual_return_rate') }}</span>
                <span class="font-14 color-green">1.5% - 2.6%</span>
              </div>
            </div>
          </div>
          <div class="flex align-center jus-bet btn-group" v-if="false">
            <a-button @click="visible = false">{{ $t('investment.cancel') }}</a-button>
            <a-button disabled>{{ $t('investment.confirm') }}</a-button>
          </div>
        </div>
      </a-modal>
    </a-layout-content>
    <a-layout-footer>
      <Footer></Footer>
    </a-layout-footer>
  </a-layout>
</template>
<script>
import Footer from "@/components/Footer/footer.vue";
import PageNav from "@/components/PageNav/PageNav.vue";

export default {
  components: {PageNav, Footer},
  data() {
    return {
      visible: false,
      radioVal: "1",
      openAll: false,
      rdpType: false
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    radioChange(e) {
      console.log(e);
      this.radioVal = e;
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./pledge.scss";
</style>
